import React from "react";
import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="min-h-screen pt-40 pb-32 px-6 text-center">
      <div className="max-w-lg mx-auto">
        <h1 className="font-serif text-4xl font-light">Checkout cancelled</h1>
        <p className="text-charcoal/60 mt-3">Your bag is still saved. Whenever you're ready, we'll be here.</p>
        <Link to="/cart" data-testid="cancel-back-cart" className="inline-flex items-center gap-3 bg-ocean text-sand px-8 py-4 overline mt-8 hover:opacity-90 transition-opacity">
          Return to bag
        </Link>
      </div>
    </div>
  );
}
